import React, { JSX } from 'react';
import { getUnreadMessagesCount } from '../../../reduxStore/selectors/messages.selector';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import useIntersectionObserver from '@react-hook/intersection-observer';
import { useIntl } from 'react-intl';
import { chatFrameMessages } from './i18n';
import { BreakLine } from '../../UI/BreakLine/BreakLine';
import { ReactComponent as Chevron } from '@/assets/chevron-down.svg';
import { styled } from '@mui/material/styles';
import { useMessagesListRefs } from './messagesListRefs.context';

type IScrollToUnreadProps = Omit<
	JSX.IntrinsicElements['div'],
	'children' | 'ref'
>;
export const ScrollToUnread = styled(
	({ className, onClick, ...props }: IScrollToUnreadProps) => {
		const { unreadMessageLineRef } = useMessagesListRefs();
		const { isIntersecting } = useIntersectionObserver(unreadMessageLineRef);
		const unreadMessagesCount = useSelector(getUnreadMessagesCount);
		const intl = useIntl();
		const scrollToUnreadText = intl.formatMessage(
			chatFrameMessages.scroll_to_unread,
			{ count: unreadMessagesCount },
		);

		const hasUnreadMessageLineRef = !!unreadMessageLineRef;
		const hasUnreadMessages = unreadMessagesCount > 0;
		const shouldHide =
			!hasUnreadMessageLineRef || !hasUnreadMessages || isIntersecting;

		// console.log('[ScrollToUnread] Hidden', {
		// 	hasUnreadMessageLineRef,
		// 	hasUnreadMessages,
		// 	unreadMessagesCount,
		// 	isIntersecting,
		// });
		if (shouldHide) {
			return null;
		}
		return (
			<BreakLine
				className={classNames('scroll-to-unread', className)}
				onClick={(e) => {
					unreadMessageLineRef.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
					onClick?.(e);
				}}
				{...props}
			>
				<Chevron className="icon chevron" />
				<span>{scrollToUnreadText}</span>
				<Chevron className="icon chevron" />
			</BreakLine>
		);
	},
	{ label: 'ScrollToUnread', target: 'ScrollToUnread-root' },
)({
	cursor: 'pointer',
	'& .icon.chevron': {
		width: '1em',
		margin: '0 0.5em',
		'& .st0': {
			stroke: 'var(--breakline_color)',
		},
	},
});
